import React, { useState, createContext } from "react"

export const UserProgramContext = createContext({
    userPrograms: [],
    setUserPrograms: () => {},

    preselectedPatientProgram: null,
    setPreselectedPatientProgram: () => {},

    fetchingUserPrograms: false,
    setFetchingUserPrograms: () => {},

    fetchingPreselectedPatientProgram: true,
    setFetchingPreselectedPatientProgram: () => {}
})

export default function ProgramProvider(props) {
    const { children } = props
    const [userPrograms, setUserPrograms] = useState([])
    const [fetchingUserPrograms, setFetchingUserPrograms] = useState(false)

    const [preselectedPatientProgram, setPreselectedPatientProgram] = useState(null)
    const [fetchingPreselectedPatientProgram, setFetchingPreselectedPatientProgram] = useState(true)

    return (
        <UserProgramContext.Provider
            value={{
                userPrograms,
                setUserPrograms,
                fetchingUserPrograms,
                setFetchingUserPrograms,

                preselectedPatientProgram,
                setPreselectedPatientProgram,
                fetchingPreselectedPatientProgram,
                setFetchingPreselectedPatientProgram
            }}
        >
            {children}
        </UserProgramContext.Provider>
    )
}
